'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Events = require('constants/Events');
const Constants = require('constants/Constants');

require('./PlatformCardExperience.less');

require('owl.carousel/src/scss/_core.scss');
require('owl.carousel/src/scss/_animate.scss');
require('owl.carousel');

const Authorization = require('./Steps/Authorization/Authorization');
const Verification = require('./Steps/Verification/Verification');
const Final = require('./Steps/Final/Final');

const Selectors = {
    el: '.PlatformCardExperience',
    content: '.PlatformCardExperience-content',
    slider: '.PlatformCardExperience-steps',
    sliderWrapper: '.PlatformCardExperience-steps',
    sliderStep: '.PlatformCardExperience-step',
    sliderStepItem: '.PlatformCardExperience-stepsItem',
    sliderStepItemTitle: '.PlatformCardExperience-stepsItemTitle',

    videoWrapper: '.PlatformCardExperience-figureStepVideo'
};

const BindFunctions = [
    'onResize',
    'onScroll',
    'setItemActive',
    'progressVideo',
    'progressStep',
    'canVideoBeAutoPlayed',
    'setFirstPosition',
    'progressAnimation',
    'setActiveVideo'
];

const ChildViews = {
    'PlatformCardExperienceAuthorizationStep': {
        selector: '.PlatformCardExperienceAuthorizationStep',
        viewConstructor: Authorization
    },
    'PlatformCardExperienceVerificationStep': {
        selector: '.PlatformCardExperienceVerificationStep',
        viewConstructor: Verification
    },
    'PlatformCardExperienceFinal': {
        selector: '.PlatformCardExperienceFinal',
        viewConstructor: Final
    }
};

const VideoDurations = [
    4,
    0,
    0,
    2.917,
    2.4,
    1.034
];

const StepsCount = 6; // Without Final step
const VideoSequencePathName = 'video/';
const VideoSequencePatternName = '0';

const OffsetPercentPlayVideos = 0.3; //offset of progress for playing video in percents / 100

module.exports = Base.extend({

    el: Selectors.el,

    events: {},

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        this.options = options;

        _.bindAll(this, BindFunctions);

        this.isDesktop = window.matchMedia('(min-width: 768px)').matches;
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;
        this.slideStepsLocked = false;
        this.slideStep = -1;

        this._initVariables();

        app.vent.on(Events.common.resize, this.onResize);
        app.vent.on(Events.common.scroll, this.onScroll);

        this.viewsRegistration(ChildViews);

        this.steps = {
            'authorization': this.views.PlatformCardExperienceAuthorizationStep,
            'verification': this.views.PlatformCardExperienceVerificationStep,
            'final': this.views.PlatformCardExperienceFinal
        };

        if (this.isDesktop) {
            this.initBlocks();
            this.createVideo(app.settings.isIE);

            this.blocks[0].isActive = false;
            this.blocks[0].isShown = false;
        }

        if (this.isMobile) {
            this.canVideoBeAutoPlayed(app.settings.hasAutoPlay);
        }

        this.onResize();
    },

    canVideoBeAutoPlayed: function (hasAutoPlay) {
        this.createVideo(app.settings.isIE || app.settings.isEdge || !hasAutoPlay);
    },

    initBlocks: function () {
        this.blocks = [];

        this.$steps.each((id, item) => {
            const $item = $(item);

            const block = {
                $el: $item,
                $stepItem: $item.find(Selectors.sliderStepItem),
                isActive: false,
                isShown: false,
                isPlayed: false,
                isPlaying: false,
                progress: 0
            };

            this.blocks.push(block);
        });
    },

    _initVariables: function () {
        this.countVideoLoaded = 0;
        this.$steps = this.$(Selectors.sliderStep);
        this.countOfSteps = this.$steps.length;
        this.state = {
            isFirstPositionSet: false,
            isFinalScene: false,
            isMobilePlayed: false
        };
        this.$sequenceWrapper = this.$(Selectors.slider);
        this.$sequenceWrapperInner = this.$(Selectors.videoWrapper);
        this.videoSequenceAssetsFolder = this.$sequenceWrapper.data('assets-folder');
    },

    createVideo: function (isFallback) {
        const params = {
            path: `${this.videoSequenceAssetsFolder}${VideoSequencePathName}${VideoSequencePatternName}`,
            className: 'PlatformCardExperience-figureVideo PlatformCardExperience-figureVideo_'
        };

        this.videos = [];

        this.$steps.each((id, item) => {
            const $item = $(item);
            const i = id + 1;
            let prefix = '';

            if (i !== 2 && i !== 3 && !$item.hasClass('PlatformCardExperienceFinal')) {
                if (!isFallback) {
                    let callbackForward = (() => {
                        this.countVideoLoaded++;

                        if (this.countVideoLoaded === this.countOfSteps) {
                            this.onResize();
                        }
                    });

                    if (i === 1 && this.isMobile) {
                        prefix = '_mob';
                    }

                    const videoParams = {
                        path: `${params.path}${i}${prefix}.mp4`,
                        $container: $item.find(Selectors.videoWrapper),
                        className: `${params.className}${i}`,
                        callback: callbackForward
                    };

                    const video = app.utils.createVideoSequence(videoParams);

                    const videoObj = {
                        video,
                        duration: VideoDurations[id],
                        progress: 0,
                        isPlayed: false
                    };

                    this.videos.push(videoObj);
                } else {
                    const img = $('<img>')
                        .addClass(`${params.className}${i}`)
                        .attr('src', `${params.path}${i}.png`)
                        .appendTo($item.find(Selectors.videoWrapper))[0];

                    const imgObj = {
                        img
                    };

                    this.videos.push(imgObj);
                }
            } else {
                if (!$item.hasClass('PlatformCardExperienceFinal')) {
                    this.videos.push({
                        duration: VideoDurations[id],
                        progress: 0,
                        isPlayed: false
                    });
                }
            }
        });
    },

    onScroll: function (scrollTop) {
        let scroll = scrollTop - this.blockOffsetTop;
        let scrollClay;
        let singleBlockHeight;
        let activeBlock;
        let curActiveVideo;
        let progress;
        let clayProgress;

        if (scroll < 0) {
            if (!this.state.isFirstPositionSet) {
                this.state.isFirstPositionSet = true;
                this.progressStep(0, 1);
            }
        }

        if (this.isMobile) {
            if (scroll > -100) {
                if (!this.state.isMobilePlayed) {
                    let $step = this.$(Selectors.sliderStep).eq(0);

                    this.state.isMobilePlayed = true;
                    this.playStep($step);
                }
            }
        } else {
            singleBlockHeight = this.blockHeight / StepsCount;
            activeBlock = Math.floor(scroll / singleBlockHeight);
            progress = Math.max(Math.min((scroll - activeBlock * singleBlockHeight) / singleBlockHeight, 1), 0);

            activeBlock += 1;

            scrollClay = scroll + singleBlockHeight * (1 - OffsetPercentPlayVideos);
            curActiveVideo = Math.floor(scrollClay / singleBlockHeight);
            clayProgress =
                Math.max(
                    Math.min(
                        (scrollClay - curActiveVideo * singleBlockHeight) / singleBlockHeight,
                        1),
                    0);

            if (this.curActiveVideo !== curActiveVideo) {
                this.setActiveVideo(curActiveVideo);
                this.curActiveVideo = curActiveVideo;
            }

            if (activeBlock === 6) {
                if (progress >= 0.04) {
                    if (!this.state.isFinalScene) {
                        this.$el
                            .addClass(Constants.cssClasses.isSuccess)
                            .removeClass('Backwards');
                        this.steps.final.resetState();
                        this.steps.final.onActive();
                        this.state.isFinalScene = true;
                    }
                } else if (this.state.isFinalScene) {
                    this.state.isFinalScene = false;
                    this.$el.addClass('Backwards');
                    this.steps.final.onInActive();
                    this.$el.removeClass(Constants.cssClasses.isSuccess);
                }
            } else if (activeBlock < 6 && this.state.isFinalScene) {
                this.state.isFinalScene = false;
                this.$el.addClass('Backwards');
                this.steps.final.onInActive();
                this.$el.removeClass(Constants.cssClasses.isSuccess);
            }

            if (activeBlock <= 5) {
                this.$el.removeClass('Backwards');
            }

            if (curActiveVideo < 0) {
                if (!this.state.isFirstPositionSet) {
                    this.progressVideo(0, 0);
                    this.progressStep(0, 1);
                } else {
                    return;
                }
            }

            if (activeBlock === 0) {
                this.progressStep(activeBlock, 1);
            }

            if (curActiveVideo === 0) {
                const curRelativeProgress = (clayProgress - OffsetPercentPlayVideos) / (1 - OffsetPercentPlayVideos);

                if (clayProgress < OffsetPercentPlayVideos) {
                    this.progressVideo(0, 0);
                } else if (curRelativeProgress > 0) {
                    this.progressVideo(curActiveVideo, curRelativeProgress);
                }
            }

            if (curActiveVideo >= 1 && curActiveVideo < StepsCount) {
                this.progressVideo(curActiveVideo, clayProgress);
            }

            if (activeBlock >= 1 && activeBlock < StepsCount) {
                this.progressStep(activeBlock, progress);
            }

            if (!this.state.isFirstPositionSet) {
                this.setFirstPosition(activeBlock);
            }

            if (this.state.blockActive === activeBlock) {
                return;
            }

            this.state.blockActive = activeBlock;
            this.setItemActive(activeBlock);
        }
    },

    onResize: function () {
        this.isDesktop = window.matchMedia('(min-width: 768px)').matches;
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (this.isDesktop) {
            this.toggleCarousel(false);

            const heightContent = this.$(Selectors.content).innerHeight();
            let heightClosedItems = 0;

            this.sectionsResizes = _.map(this.$(Selectors.sliderStepItemTitle), (item) => {
                const $item = $(item);
                const heightItem = $item.innerHeight();

                return {
                    minHeight: heightItem,
                    maxHeight: heightItem,
                    rangeHeight: 0
                };
            });

            for (let i = 0; i < this.sectionsResizes.length; i++) {
                const isLast = i === this.sectionsResizes.length - 1;
                let maxHeight = this.sectionsResizes[i].maxHeight;
                let minHeight = this.sectionsResizes[i].minHeight;
                let nextHeight = (!isLast) ? this.sectionsResizes[i + 1].minHeight : 0;

                heightClosedItems += minHeight;

                maxHeight = Math.max((heightContent - heightClosedItems - nextHeight), minHeight * 2);

                this.sectionsResizes[i].maxHeight = maxHeight;
                this.sectionsResizes[i].rangeHeight = maxHeight - minHeight;

                this.blocks[i].$stepItem.css('height', maxHeight);
            }

            this.offsetStepsWrapper = this.$(Selectors.sliderWrapper)[0].getBoundingClientRect();

            app.vent.trigger('platform-final-resize', this.sectionsResizes, this.offsetStepsWrapper);

            this.blockOffsetTop = this.$el.offset().top;
            this.blockHeight = this.$el.height();

            this.wh = window.app.sizes.windowHeight;
        } else {
            setTimeout((function () {
                this.blockOffsetTop = this.$el.offset().top;
            }).bind(this), 500);
            this.toggleCarousel(true);
        }

        if (!this.videos) {
            return;
        }

        this.onScroll(window.pageYOffset);
    },

    setFirstPosition: function (index) {
        this.state.isFirstPositionSet = true;

        if (this.isMobile) {
            return;
        }

        for (let i = 0; i <= index; i++) {
            if (i !== index) {
                this.blocks[i].$el
                    .addClass(Constants.cssClasses.isShown)
                    .removeClass(Constants.cssClasses.isActive);
                this.blocks[i].isActive = false;
                this.blocks[i].isShown = true;
            } else {
                this.blocks[i].$el.addClass(Constants.cssClasses.isActive);
                this.blocks[i].isActive = false;
                this.blocks[i].isShown = false;
            }
        }
    },

    setItemActive: function (index) {
        if (this.isMobile) {
            return;
        }

        const currentItem = this.blocks[index];
        const nextItem = this.blocks[index + 1];
        const prevItem = this.blocks[index - 1];

        // for set right position with bugs and lags
        for (let i = 0; i < index - 1; i++) {
            const item = this.blocks[i];

            if (this.sectionsResizes[i]) {
                const minH = this.sectionsResizes[i].minHeight;

                item.$stepItem.css('max-height', minH);

                if (!item.isShown) {
                    item.$el
                        .removeClass(Constants.cssClasses.isActive)
                        .addClass(Constants.cssClasses.isShown);

                    item.isActive = false;
                    item.isShown = true;
                }
            }
        }

        if (prevItem) {
            prevItem.$el
                .removeClass(Constants.cssClasses.isActive)
                .addClass(Constants.cssClasses.isShown);
            prevItem.isActive = false;
            prevItem.isShown = true;
        }

        if (currentItem) {
            currentItem.$el
                .addClass(Constants.cssClasses.isActive)
                .removeClass(Constants.cssClasses.isShown);
            currentItem.isActive = false;
            currentItem.isShown = false;

            if (index === 0) {
                currentItem.$stepItem.css('max-height', this.sectionsResizes[index].maxHeight);
            }

            // if (index === 1) {
            //     app.vent.trigger('platform-authorization-toggle', true);
            // }
        }

        if (nextItem) {
            nextItem.$el
                .removeClass(Constants.cssClasses.isActive)
                .removeClass(Constants.cssClasses.isShown);
            nextItem.isActive = false;
            nextItem.isShown = false;
        }
    },

    setActiveVideo: function (index) {
        if (this.isMobile) {
            return;
        }

        const currentItem = this.blocks[index];
        const nextItem = this.blocks[index + 1];
        const prevItem = this.blocks[index - 1];

        // for set right position with bugs and lags
        for (let i = 0; i < index - 1; i++) {
            const item = this.blocks[i];


            if (!item.isPlayed) {
                item.$el
                    .removeClass(Constants.cssClasses.isPlaying)
                    .addClass(Constants.cssClasses.isPlayed);
            }
        }

        if (prevItem) {
            prevItem.$el
                .removeClass(Constants.cssClasses.isPlaying)
                .addClass(Constants.cssClasses.isPlayed);

            prevItem.isPlayed = true;
            prevItem.isPlaying = false;
        }

        if (currentItem) {
            currentItem.$el
                .addClass(Constants.cssClasses.isPlaying)
                .removeClass(Constants.cssClasses.isPlayed);

            currentItem.isPlayed = false;
            currentItem.isPlaying = true;

            if (index - 1 === 1) {
                app.vent.trigger('platform-authorization-toggle', true);
            }
        }

        if (nextItem) {
            nextItem.$el
                .removeClass(Constants.cssClasses.isPlaying)
                .removeClass(Constants.cssClasses.isPlayed);

            nextItem.isPlayed = false;
            nextItem.isPlaying = false;
        }
    },

    progressAnimation: function (index, progress) {
        if (index === 2) {
            app.vent.trigger('platform-verification-progress', {index: index, progress: progress});
        }
    },

    progressVideo: function (index, progress) {
        const videoObj = this.videos[index];

        if (progress === videoObj.progress) {
            return;
        }

        if (index === 2) {
            this.progressAnimation(index, progress);
        }

        if (!videoObj.video) {
            return;
        }

        videoObj.progress = progress;
        videoObj.video.currentTime = videoObj.duration * progress;
    },

    progressStep: function (index, progress) {
        if (this.isMobile) {
            return;
        }

        const currentItem = this.blocks[index];

        if (currentItem) {
            if (progress === currentItem.progress) {
                return;
            }

            const curItemProgressHeight = progress * this.sectionsResizes[index].rangeHeight;
            const minCurItemHeight = this.sectionsResizes[index].minHeight;
            currentItem.progress = progress;
            currentItem.$stepItem.css('max-height', (minCurItemHeight + curItemProgressHeight));
        }

        const prevItem = this.blocks[index - 1];

        if (prevItem) {
            const prevItemProgressHeight = progress * this.sectionsResizes[index - 1].rangeHeight;
            const maxPrevItemHeight = this.sectionsResizes[index - 1].maxHeight;
            prevItem.progress = progress;
            prevItem.$stepItem.css('max-height', (maxPrevItemHeight - prevItemProgressHeight));
        }
    },

    animateStep: function () {
        this.slideStepsLocked = true;

        let $step = this.$(Selectors.sliderStep).eq(this.slideStep);

        this.playStep($step);
    },

    toggleCarousel: function (isActive) {
        if (isActive === this.isCarouselActive) {
            return;
        }

        if (isActive) {
            this.$(Selectors.slider)
                .addClass('owl-carousel owl-theme')
                .owlCarousel({
                    autoWidth: true,
                    stagePadding: 0,
                    // items: 1,
                    margin: 0,
                    center: true,
                    // singleItem: false,
                    loop: false,
                    dots: false
                });

            this.$(Selectors.slider).on('changed.owl.carousel', function (e) {
                if (e.item.index === null) {
                    return;
                }

                let $step = this.$(Selectors.sliderStep).eq(e.item.index);
                this.playStep($step);
            }.bind(this));
        } else {
            this.$(Selectors.slider)
                .owlCarousel('destroy')
                .removeClass('owl-carousel owl-theme');
        }

        this.isCarouselActive = isActive;
    },

    playStep: function ($stepEl) {
        this._resetSteps();
        $stepEl.addClass(Constants.cssClasses.isActive);

        if ($stepEl.data('type') === 'video') {
            this._playStepVideo($stepEl);
        } else {
            this._playStepAnimation($stepEl);
        }
    },

    _resetSteps: function () {
        this.$(Selectors.sliderStep)
            .removeClass(Constants.cssClasses.isActive)
            .removeClass(Constants.cssClasses.isAnimation);

        for (let step in this.steps) {
            if (this.steps[step]) {
                this.steps[step].onInActive();
            }
        }
    },

    _playStepVideo: function ($stepEl) {
        let video = $stepEl.find('.PlatformCardExperience-figureVideo');
        if (video.length) {
            let videoEl = video[0];
            app.utils.forcePlay(videoEl);
        }
    },

    _playStepAnimation: function ($stepEl) {
        let stepId = $stepEl.data('id');

        if (this.steps[stepId]) {
            this.steps[stepId].onActive();
        }
    }

});
